import "regenerator-runtime/runtime.js";
import { API } from "./api";

import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from "amazon-cognito-identity-js";

import { ENVIRONMENT_NAMES, getEnvironment } from "./deploymentUtils";

const COGNITO = (() => {
  return {
    APP_CLIENT_ID: "$APP_CLIENT_ID$",
    USER_POOL_ID: "$USER_POOL_ID$",
  };
})();

export const USER_POOL = new CognitoUserPool({
  ClientId: COGNITO.APP_CLIENT_ID,
  UserPoolId: COGNITO.USER_POOL_ID,
});

export const getSession = async (isLogin = false) => {
  return await new Promise((resolve, reject) => {
    const environment = getEnvironment();
    if (environment === ENVIRONMENT_NAMES.LOCAL) {
      const token = sessionStorage.getItem("access_token");
      if (token) {
        sessionStorage.setItem(
          "exp",
          (Math.floor(new Date().getTime() / 1000) + 60 * 60).toString()
        );
        resolve({
          accessToken: {
            jwtToken: token,
          },
        });
      } else {
        reject({ code: 403, message: "SESSION EXPIRED" });
      }
    } else {
      const user = USER_POOL.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject(err);
          } else {
            if (!isSameId()) {
              reject({ code: 403, message: "SESSION EXPIRED" });
            }
            if (!isLogin) {
              const refreshToken = session.getRefreshToken();
              user.refreshSession(
                refreshToken,
                (refreshErr, refreshSession) => {
                  if (refreshErr) {
                    reject({ code: 403, message: "SESSION EXPIRED" });
                  } else {
                    sessionStorage.setItem(
                      "exp",
                      refreshSession.idToken.payload.exp
                    );
                    resolve({ user, ...refreshSession });
                  }
                }
              );
            } else {
              resolve({ user, ...session });
            }
          }
        });
      } else {
        reject({ code: 403, message: "SESSION EXPIRED" });
      }
    }
  });
};

export const authenticate = async (Username, Password) => {
  return await new Promise((resolve, reject) => {
    const environment = getEnvironment();
    if (environment === ENVIRONMENT_NAMES.LOCAL) {
      fetch(API.BACKEND.URL + "/api/login/", {
        method: "POST",
        headers: {
          accept: "*/*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST,GET,DELETE,PUT,PATCH",
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          username: Username,
          password: Password,
        }),
      })
        .then((res) => {
          console.log(res.status);
          return res.json();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
        .then((res) => {
          if (res.status_code) {
            reject(res);
          } else {
            sessionStorage.setItem("access_token", res.access_token);
            resolve({
              accessToken: {
                jwtToken: res.access_token,
              },
            });
          }
        });
    } else {
      const user = new CognitoUser({ Username, Pool: USER_POOL });
      const authDetails = new AuthenticationDetails({ Username, Password });
      user.authenticateUser(authDetails, {
        onSuccess: () => {
          storeSession();
          user.setAuthenticationFlowType("CUSTOM_AUTH");
          user.initiateAuth(authDetails, {
            onSuccess: () => {
              user.setAuthenticationFlowType("USER_SRP_AUTH");
              user.authenticateUser(authDetails, {
                onSuccess: (data) => {
                  resolve({ user, ...data });
                },
                onFailure: (err) => {
                  reject(err);
                },
              });
            },
            onFailure: (err) => {
              reject(err);
            },
          });
        },
        onFailure: (err) => {
          reject(err);
        },
        newPasswordRequired: (data) => {
          resolve({ user, status: "new_password_required", ...data });
        },
      });
    }
  });
};

function storeSession() {
  const id = Date.now();
  sessionStorage.setItem("id", id.toString());
  localStorage.setItem("id", id.toString());
}

function isSameId() {
  const sessionId = sessionStorage.getItem("id");
  const localId = localStorage.getItem("id");
  return sessionId && localId && localId === sessionId;
}

export const logout = () => {
  const environment = getEnvironment();
  if (environment === ENVIRONMENT_NAMES.LOCAL) {
    sessionStorage.removeItem("access_token");
  } else {
    const user = USER_POOL.getCurrentUser();
    if (user) {
      user.signOut();
    }
  }
};
